import React, { useState } from 'react'
import qs from 'qs'
import MNWaterfallApi from 'component/waterfall/masonryApi'
// import CustomizeHeader from '../../components/header/customizeHeader'
import InfoWrap from './infoWrap'
import Card from './card'
import styles from './index.module.less'

export default () => {
  const [total, setTotal] = useState(0)
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })

  return <>
    {/* <CustomizeHeader
      style={{ zIndex: 100 }}
      renderLeft={() => <div />}
    /> */}
    <div className={styles['mn-official-inspiration']}>
      <InfoWrap
        info={{
          name: query.name
        }}
        total={total}
      />
      <div style={{ marginTop: '24px' }}>
        <MNWaterfallApi
          renderItem={Card}
          gutter={16}
          url="/zhikuan/mn/recommend/list-daily-recommend-blogs"
          method="post"
          params={{
            dailyName: query.name
          }}
          onTotal={(val) => {
            setTotal(val)
          }}
        />
      </div>
    </div>
  </>
}
